import { Grid, Button, Box } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import styles from "../../Styles/examFooter.module.css";

interface ExamFooterProps {
  showResult: boolean;
  handleNext: () => void;
  handleSubmit: () => void;
  setSelected: (val: number[]) => void;
  allAnswered?: boolean;
}

export default function ExamFooter({
  showResult,
  handleNext,
  handleSubmit,
  setSelected,
  allAnswered = false,
}: ExamFooterProps) {
  return (
    <Box className={styles.footerContainer}>
      <Grid container justifyContent="center" spacing={1} className={styles.footerGrid}>
        <Grid item xs={6} lg={4}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleNext}
            disabled={showResult}
            fullWidth
            className={`${styles.footerButton} ${styles.laterButton}`}
            startIcon={<ReplayIcon sx={{ color: "#495057" }} />}
          >
            Răspunde mai târziu
          </Button>
        </Grid>
        <Grid item xs={6} lg={4}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setSelected([])}
            disabled={showResult}
            fullWidth
            className={`${styles.footerButton} ${styles.modifyButton}`}
            startIcon={<CloseIcon sx={{ color: "#b71c1c" }} />}
          >
            MODIFICĂ RĂSPUNSUL
          </Button>
        </Grid>
        <Grid item xs={12} lg={4} justifyContent="center">
          {!showResult ? (
            <Button
              variant="contained"
              color="success"
              onClick={handleSubmit}
              fullWidth
              className={`${styles.footerButton} ${styles.submitButton}`}
              startIcon={<CheckCircleIcon sx={{ color: "#fff" }} />}
            >
              TRIMITE RĂSPUNSUL
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleNext}
              fullWidth
              disabled={allAnswered}
              className={`${styles.footerButton} ${styles.nextButton}`}
            >
              URMĂTOAREA ÎNTREBARE
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
